import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { JobListing, JobPagination, JobsListResponse } from '../interface/jobs.interface';
import { fetchPublicJobs } from '../thunks/jobs.thunk';

interface JobsState {
  jobs: JobListing[];
  pagination: JobPagination | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: JobsState = {
  jobs: [],
  pagination: null,
  isLoading: false,
  error: null,
};

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    clearJobsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicJobs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPublicJobs.fulfilled, (state, action: PayloadAction<JobsListResponse>) => {
        state.isLoading = false;
        state.jobs = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchPublicJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = (action.payload as string) || 'Failed to load jobs.';
      });
  },
});

export const { clearJobsError } = jobsSlice.actions;
export default jobsSlice.reducer;
